export default "__VITE_ASSET__ELe0JUrS__"